export default __webpack_public_path__ + "static/media/opened_menu.f5f6e4a8.svg";